import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { Dispatch } from 'models/meta/action';
import { finishWorkflow } from 'store/actions/workflow';

import { ConsentDeclinedDispatchProps } from './ConsentDeclined.types';
import ConsentDeclined from './ConsentDeclined.layout';


const mapDispatchToProps = (dispatch: Dispatch): ConsentDeclinedDispatchProps =>
    ({ dispatchFinishWorkflow: () => dispatch(finishWorkflow()) });


export default connect(null, mapDispatchToProps)(withTranslation('result-screen')(ConsentDeclined));
